module.exports = __webpack_public_path__ + "img/14.a006100a.png";